<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_13"></a><a id="part1"></a>THE STORIES</h2>
<p class="pagebreak">
</p><p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="image"><a id="page_14"></a><img alt="Image" src="images/f0014-01.jpg"/></p>
<p class="caption"><em>Stalking the flats around Jardines de la Reina, where tarpon, bone-fish, permit—and crocodiles—make for excellent sport.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?64bd2ca7